import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useContent } from '../../../../../redux/reducer/content';
import { GTMFriendReaction } from '../../../../../constants/analytics/GTM';

export default function useSetReaction() {
  const { viewedFriend } = useContent();

  const callbacks = useApplicationCallbacks();

  return (clickData) => {
    const callbackKey = `set${viewedFriend?.isLiked === clickData ? 'Dislike' : 'Like'}`;
    const reactionCallback = callbacks[callbackKey];
    reactionCallback({ uid: viewedFriend?.uid, type: clickData });
    GTMFriendReaction();
  };
}
